import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { TestResource } from "./TestResource";

export class TestChildResource {
  constructor(public readonly id: number, public readonly testBoolean: boolean, public readonly testResource: TestResource | null) {
    this.cbiServiceContext = null;
    this.testResourceLoaded = this.testResource != null;
    this.testResourceCached = this.testResource;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private testResourceLoaded: boolean;
  private testResourceCached: TestResource | null;
  async testResourceLazy(): Promise<TestResource> {
    if (!this.testResourceLoaded) {
      this.testResourceCached = await this.cbiServiceContext!.testResourceService().getTestChildResourceTestResource(this.id);
      this.testResourceLoaded = true;
    }
    return this.testResourceCached!;
  }
  async describeChild(required: string, prefix: string, suffix: string): Promise<string> {
    return await this.cbiServiceContext!.testResourceService().describeChildStaff({ dto: { id: this.id }, required: required, prefix: prefix, suffix: suffix });
  }
  async formatChildLabels(firstLabel: string, secondLabel: string): Promise<string> {
    return await this.cbiServiceContext!.testResourceService().formatChildLabelsStaff({ dto: { id: this.id }, firstLabel: firstLabel, secondLabel: secondLabel });
  }
}
